<template>
    <div class="pageWrap" v-loading="loading"> 
        <div class="pagechange">
            <div class="redBlock"></div>
            <div class="headerText">开机时长管理</div>
        </div>
        <div class="oildataPicker">
            <span class="name">日期</span>
            <el-date-picker
                v-model="value1"
                type="daterange"
                unlink-panels
                style="margin-left: 10px; margin-right: 10px"
                start-placeholder="选择开始日期"
                end-placeholder="选择结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
            </el-date-picker>
            <el-button type="danger" @click="confirm">确认</el-button>
        </div>
        <div class="left">
            <div class="size color1">
                <span class="date">{{dayMaxDate?dayMaxDate.replace('/','月')+'日':''}}</span>
                <span :class="heightime=='无数据'?'fontSize23':''">{{heightime}}</span>
                <span class="column">单日最高开机时长</span>
            </div>
            <div class="size  color2">
                <span class="date">{{dayMinDate?dayMinDate.replace('/','月')+'日':''}}</span>
                <span :class="lowtime=='无数据'?'fontSize23':''">{{lowtime}}</span>
                <span  class="column">单日最低开机时长</span>
            </div>
            <div class="size  color3">
                <span :class="avetime=='无数据'?'fontSize23':''">{{avetime}}</span>
                <span class="column">日均开机时长</span>
            </div>
            <div class="size  color4">
                <span :class="totaltime*1>10000?'fontSize36':totaltime=='无数据'?'fontSize23':''">{{totaltime}}</span>
                <span class="column">累计总开机时长</span>
            </div>
            <div class="unit">
                <span>单位：小时</span>
            </div>
        </div>
        <!-- <div class="line" style="height:500px;background-color:#E1E1E1;width:1px;margin-top:80px"></div> -->
        <div class="right">
            <div class="search-form-group">
                <el-radio-group v-model="period" size="medium" @change="periodChange">
                <el-radio-button label="0">按日</el-radio-button>
                <!-- <el-radio-button label="1">按周</el-radio-button> -->
                <el-radio-button label="2">按月</el-radio-button>
                </el-radio-group>
            </div>
            <div class="tableline">
                <WorkTimeChart ref="workTimeChart" :dataBar="debugPlan" :colorSet="colorLine" :legendGrid="legendGrid" :grid="grid"/>
            </div>
        </div>
    </div>
        
   
</template>
<script>
    import WorkTimeChart from "../../../components/chart/workTimeChart";
    import {getEquipUsageTime,getEquipStatistics} from "../../../utils/api";
    import {dateTransfor1,dateTransfor} from "../../../utils/commons";
    import {Message} from 'element-ui'
    export default{
        data(){
            return{
                period:0,
                heightime:"无数据",
                lowtime:"无数据",
                avetime:"无数据",
                totaltime:"无数据",
                dayMaxDate:'',
                dayMinDate:'',
                unit:'小时',
                loading:false,
                timer:0, //定时器id
                debugPlan:{
                    yAxis:['12/01'],
                    barData:[{
                        itemStyle: { normal: { color: 'rgba(0,0,0,0)' } },
                        name: '辅助',
                        value: [0, 23, 24]
                    },],
                    lineData:[80],
                    title: ["作业时长", "怠速时长","设备利用率"],
                    xAxisUnit: ["时长: H","设备利用率"],
                    period:0,
                    max:24,
                    dataZoomEnd: 50
                },
                colorLine: ["#597EF7", "#FFC53D", "#36CFC9"],
                legendGrid:[0,30],
                grid:[80,60,20,50],
                value1:[],
                pickerOptions: {
                    shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                    }],
                    disabledDate: (time) => {
                    return time.getTime() > Date.now();
                    }
                },
            }
        },
        props:["code","workIndex"],
        computed: {},
        created() {
            this.value1=[dateTransfor1(),dateTransfor()]
        },
        mounted() {
        },
        watch:{
            workIndex(val){
                if(val==1){
                    // this.getWorktime();
                    if(this.value1==null){
                        Message.warning('请选择时间段！')
                        return
                    }
                    this.getEquipStatisticsFun()
                    this.getEquipUsageTimeFun()
                    // this.$refs.workTimeChart.chart.resize()
                }
            },
            code(){
                this.value1=[dateTransfor1(),dateTransfor()]
                this.period=0
            }
        },
        components:{WorkTimeChart},
        methods:{
            confirm(){
                if(this.value1==null){
                    Message.warning('请选择时间段！')
                    return
                }
                this.getEquipUsageTimeFun();
                this.getEquipStatisticsFun();
            },
            periodChange(){
                if(this.value1==null){
                    Message.warning('请选择时间段！')
                    return
                }
                // this.getWorktime();
                this.getEquipStatisticsFun();
                this.getEquipUsageTimeFun();
            },
            //获取四个方格数据
            getEquipStatisticsFun(){
                let params={
                    equipCode:this.code,
                    type:0,
                    startTime:this.value1[0]+' 00:00:00',
                    endTime:this.value1[1]+' 23:59:59',
                }
                getEquipStatistics(params).then(res=>{
                    if(res.data.code==200){
                        let info=res.data.content.info
                        this.heightime=info.dayMax==0?'无数据':(info.dayMax*1).toFixed(1);
                        this.lowtime=info.dayMin==0?'无数据':(info.dayMin*1).toFixed(1);
                        this.avetime=info.dayAverage==0?'无数据':(info.dayAverage*1).toFixed(1);
                        this.totaltime=info.total==0?'无数据':(info.total*1).toFixed(1);
                        this.dayMaxDate=info.dayMaxDate;
                        this.dayMinDate=info.dayMinDate;
                    }
                })
            },
            //获取工作时长
            getEquipUsageTimeFun(){
                if(this.value1==null) this.value1=['','']
                let params={
                    equipCode:this.code,
                    mode:this.period,
                    startTime:this.value1[0],
                    endTime:this.value1[1]
                }
                this.loading=true
                getEquipUsageTime(params).then(res=>{
                    if(res.data.code==200){

                        let _dataList=res.data.content.dataList
                        let lineData=[]
                        let barData=[]
                        let _yAxis=[]
                        let max=0
                        if(this.period==0){
                            _dataList.map((item,index)=>{
                                _yAxis.push(item.dateTag)
                                lineData.push(item.utilization)
                                let time=0
                                item.usageTimes.map(j=>{
                                    if(j.type==2){
                                        barData.push({
                                            itemStyle: { normal: { color: 'rgba(0,0,0,0)' } },//条形颜色
                                            name: '辅助',
                                            value: [index, time, time+j.duration]//0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
                                        })
                                        time=time+j.duration
                                    }else if(j.type==1){
                                        barData.push({
                                            itemStyle: { normal: { color: '#FFC53D' } },
                                            name: '怠速时长',
                                            value: [index, time, time+j.duration]//0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
                                        })
                                        time=time+j.duration
                                    }else if(j.type==0){
                                        barData.push({
                                            itemStyle: { normal: { color: '#597EF7' } },
                                            name: '作业时长',
                                            value: [index, time, time+j.duration]//0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
                                        })
                                        time=time+j.duration
                                    }
                                })
                            })
                            max=24;
                        }else{
                            _dataList.map((item,index)=>{
                                _yAxis.push(item.dateTag)
                                lineData.push(item.utilization)
                                let workTime=0
                                let stateTime=0
                                let runTime=0
                                item.usageTimes.map(j=>{
                                    if(j.type==1){
                                        stateTime+=j.duration
                                    }else if(j.type==0){
                                        workTime+=j.duration
                                    }
                                })
                                runTime=workTime+stateTime
                                if(runTime>max) max=runTime
                                barData.push({
                                    itemStyle: { normal: { color: '#597EF7' } },
                                    name: '作业时长',
                                    value: [index, 0, workTime]//0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
                                })
                                barData.push({
                                    itemStyle: { normal: { color: '#FFC53D' } },
                                    name: '怠速时长',
                                    value: [index, workTime, runTime]//0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
                                })
                            })
                        }
                        this.debugPlan.yAxis=_yAxis
                        this.debugPlan.barData=barData 
                        this.debugPlan.lineData=lineData
                        this.debugPlan.title= ["作业时长", "怠速时长","设备利用率"]
                        this.debugPlan.xAxisUnit= ["时长: H","设备利用率"]
                        this.debugPlan.period=this.period
                        this.debugPlan.max=max.toFixed(2)*1
                        this.debugPlan.dataZoomEnd= Math.min(100, Math.ceil((8 / _yAxis.length) * 100))
                        this.colorLine=["#597EF7", "#FFC53D", "#36CFC9"]
                        this.legendGrid=[0,50]
                        this.grid=[60,90,20,70]
                        console.log(this.debugPlan,'this.debugPlan')
                    }
                    this.loading=false
                })
            }
        },
        
    }
    
</script>
<style lang="scss" scoped="">
    .pageWrap{
        width: 100%;
        height: 658px;
        display: flex;
        position: relative;
        .pagechange {
            position: absolute;
            left: 10px;
            top: 25px;
            display: flex;
            .redBlock {
                height: 18px;
                width: 3px;
                background-color: #e96b5a;
                margin-right: 8px;
            }
            .headerText {
                color: #404040;
                font-family: Noto Sans SC;
                font-weight: medium;
                font-size: 16px;
                line-height: 18px;
                letter-spacing: 0px;
                text-align: left;
                font-weight: bold;
            }
        }
        .oildataPicker{
            position: absolute;
            top: 65px;
            left: 8px;
            .name{
            font-size: 14px;
            }
        }
        .left{
        width: 458px;
        height: 658px;
        padding: 120px 0px 50px 0px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .size{
            width: 213px;
            height: 213px;
            border-radius: 2px;
            margin: 0px 7px;
            font-size: 46px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #222222;
            display: flex;
            flex-direction: column;
            text-align: center;
            justify-content: center;
            .column{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #555555;
                padding-top: 20px;
            }
            .fontSize36{
                font-size: 36px;
            }
            .fontSize23{
                font-size: 23px;
            }
            .date{
                font-size: 16px;
            }
        }
        .color1{
             background: #EFEFF8;
        }
        .color2{
             background:#E5F0F9;
        }
        .color3{
             background: #F8F3E4;
        }
        .color4{
             background: #FAECEA;
        }
        .unit{
            margin-left: 15px;          
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #222222;
        }
        }
        .right{
            width: 1400px;
            height: 618px;
            padding-top: 62px;
            padding-left: 40px;
            .search-form-group {
            margin-left: 18px;
            // margin-top: -18px;
            }
            .tableline{
                width: 100%;
                height: 468px;
                margin-top: 0px;
            }
        }
    }
    
</style>